export default __webpack_public_path__ + "static/media/image_tres.dd43a834.PNG";